import React from "react";
import Modal from 'react-responsive-modal';
import {NotificationContainer} from 'react-notifications';
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import CurrencyFormat from 'react-currency-format';

class JobDetailModal extends React.Component{

    state = {
        companyName: '',
        locationName: '',
        data: '',
        jobSalary: '',
        jobTitle: '',
        contract: '',
        img: '',
        seniority: ''
    }

    componentDidMount(){
        this.setState({
            companyName: this.props.data.companyName,
            locationName: this.props.data.locationName,
            jobSalary: this.props.data.jobSalary,
            data: this.props.data.data,
            jobTitle: this.props.data.jobTitle,
            img: this.props.data.img,
            contract: this.props.data.contract,
            seniority: this.props.data.seniority
        })
    }

    render() {
        return(
            <Modal open={this.props.open} onClose={this.props.close} 
             closeOnOverlayClick={false} >
                <div className="modal-detail">
                    <p className="mc-name">Detalles de la vacante</p>
                    <div className="">
                    <img src={this.state.img} className="mc-img" alt="company-detail"/>
                    <p className="mc-name">Nombre de la vacante:</p>
                    <p className="mc-text">{this.state.jobTitle}</p>
                    <p className="mc-name">Oferta económica:</p>
                    <CurrencyFormat className="mc-text" value={this.state.jobSalary} 
                    displayType={'text'} thousandSeparator={true} prefix={'$'} />
                    <p className="mc-name">Ubicación:</p>
                    <p className="mc-text">{this.state.locationName}</p>
                    <p className="mc-name">Nivel de experiencia:</p>
                    <p className="mc-text">{this.state.seniority}</p>
                    <p className="mc-name">Contrato:</p>
                    <p className="mc-text">{this.state.contract}</p>
                    <p className="mc-name">Descripción:</p>
                    <ReactQuill
                        className="description"
                        value={this.state.data}
                        readOnly={true}
                        theme={"bubble"}
                    />
                </div>
                </div>
                <NotificationContainer />
            </Modal>
        );
    }
}

export default  JobDetailModal;
